import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { angleOf } from '../utils/coordinate';
import { LinearAxis } from './axis';
function inferTitleTransform(orientation) {
  var internalOrientation = orientation % (Math.PI * 2);
  if (internalOrientation === Math.PI / 2) {
    return {
      titleTransform: 'translate(0, 50%)'
    };
  }
  if (internalOrientation > -Math.PI / 2 && internalOrientation < Math.PI / 2) {
    return {
      titleTransform: 'translate(50%, 0)'
    };
  }
  if (internalOrientation > Math.PI / 2 && internalOrientation < Math.PI * 3 / 2) {
    return {
      titleTransform: 'translate(-50%, 0)'
    };
  }
  return {};
}
function inferAxisStyle(options, theme, coordinate, scales) {
  var radar = options.radar;
  var _scales = _slicedToArray(scales, 1),
    scale = _scales[0];
  var name = scale.getOptions().name;
  var _angleOf = angleOf(coordinate),
    _angleOf2 = _slicedToArray(_angleOf, 2),
    startAngle = _angleOf2[0],
    endAngle = _angleOf2[1];
  var _theme$axisRadar = theme.axisRadar,
    radarTheme = _theme$axisRadar === void 0 ? {} : _theme$axisRadar;
  return Object.assign(Object.assign({}, radarTheme), {
    grid: name === 'position',
    gridConnect: 'line',
    gridControlAngles: new Array(radar.count).fill(0).map(function (_, i) {
      var angle = (endAngle - startAngle) / radar.count;
      return angle * i;
    })
  });
}
export var AxisRadar = function AxisRadar(options) {
  var _options$important = options.important,
    important = _options$important === void 0 ? {} : _options$important,
    restOptions = __rest(options, ["important"]);
  return function (context) {
    var theme = context.theme,
      coordinate = context.coordinate,
      scales = context.scales;
    return LinearAxis(Object.assign(Object.assign(Object.assign({}, restOptions), inferTitleTransform(options.orientation)), {
      important: Object.assign(Object.assign({}, inferAxisStyle(options, theme, coordinate, scales)), important)
    }))(context);
  };
};
AxisRadar.props = Object.assign(Object.assign({}, LinearAxis.props), {
  defaultPosition: 'center'
});